import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page rules" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { href: "#gameplay" }
const _hoisted_5 = { href: "#winning" }
const _hoisted_6 = { href: "#mission-sizes" }
const _hoisted_7 = { href: "#roles-setup" }
const _hoisted_8 = { href: "#faq" }
const _hoisted_9 = { class: "quick-start" }
const _hoisted_10 = { class: "quick-steps" }
const _hoisted_11 = { class: "rules-notes" }
const _hoisted_12 = { class: "wiki-panel example-panel" }
const _hoisted_13 = { class: "wiki-panel variant-panel" }
const _hoisted_14 = { class: "wiki-nav" }
const _hoisted_15 = { id: "gameplay" }
const _hoisted_16 = { id: "winning" }
const _hoisted_17 = { id: "mission-sizes" }
const _hoisted_18 = { class: "table" }
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = { scope: "col" }
const _hoisted_22 = { scope: "col" }
const _hoisted_23 = { scope: "col" }
const _hoisted_24 = { scope: "col" }
const _hoisted_25 = { scope: "col" }
const _hoisted_26 = { scope: "col" }
const _hoisted_27 = { scope: "row" }
const _hoisted_28 = { scope: "row" }
const _hoisted_29 = { scope: "row" }
const _hoisted_30 = { scope: "row" }
const _hoisted_31 = { scope: "row" }
const _hoisted_32 = { scope: "row" }
const _hoisted_33 = { id: "roles-setup" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "game-setup" }
const _hoisted_37 = { class: "game-setup" }
const _hoisted_38 = { class: "game-setup" }
const _hoisted_39 = { class: "game-setup" }
const _hoisted_40 = { class: "game-setup" }
const _hoisted_41 = { class: "game-setup" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { id: "faq" }
const _hoisted_44 = ["id"]
const _hoisted_45 = {
  ref: "roleOptionsLauncher",
  class: "rules-role-options"
}
const _hoisted_46 = { class: "mt-2" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 2 }
const _hoisted_66 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_LocaleLink = _resolveComponent("LocaleLink")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_LocalizedTextWrapper = _resolveComponent("LocalizedTextWrapper")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_PreviewLink = _resolveComponent("PreviewLink")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('rules.title')), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('rules.gameDescription')), 1),
    _createElementVNode("nav", {
      class: "rules-contents wiki-nav",
      "aria-label": _ctx.$t('wiki.rules')
    }, [
      _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('rules.gameplayRules')), 1),
      _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('rules.conclusionOfGameplayTitle')), 1),
      _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('rules.missionSizes')), 1),
      _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('rules.recommendTitle')), 1),
      _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('rules.faqTitle')), 1)
    ], 8, _hoisted_3),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('rules.quickStartTitle')), 1),
      _createElementVNode("ol", _hoisted_10, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (step) => {
          return _createElementVNode("li", { key: step }, _toDisplayString(_ctx.$t(`rules.quickStep${step}`)), 1)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("section", _hoisted_12, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.roundExampleTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('rules.roundExample')), 1)
        ]),
        _createElementVNode("section", _hoisted_13, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.variantTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('rules.variantNote')), 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_14, [
        _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('wiki.rolesTitle')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('rules.gameObjective')), 1),
    _createVNode(_component_i18n_t, {
      keypath: "rules.objectiveArthur",
      tag: "h3",
      scope: "global"
    }, {
      goodLoyaltyIcon: _withCtx(() => _cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "good-loyalty-icon" }, null, -1)
      ])),
      _: 1
    }),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "rules.missionObjective" })
    ]),
    _createVNode(_component_i18n_t, {
      keypath: "rules.objectiveMordred",
      tag: "h3",
      scope: "global"
    }, {
      evilLoyaltyIcon: _withCtx(() => _cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "evil-loyalty-icon" }, null, -1)
      ])),
      _: 1
    }),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "rules.minionObjective" })
    ]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.additionalObjectivesTitle')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "rules.additionalObjectivesDescription" })
    ]),
    _createVNode(_component_v_divider, { thickness: 5 }),
    _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.$t('rules.gameplayRules')), 1),
    _createElementVNode("h3", null, "1. " + _toDisplayString(_ctx.$t('rules.teamProposalAndVoting')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.teamProposalDescription')), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.votingDescription')), 1)
    ]),
    _createElementVNode("h3", null, "2. " + _toDisplayString(_ctx.$t('rules.missionPhaseTitle')), 1),
    _createElementVNode("ul", null, [
      _createVNode(_component_i18n_t, {
        keypath: "rules.teamApproved",
        tag: "li",
        scope: "global"
      }, {
        goodLoyaltyIcon: _withCtx(() => _cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "good-loyalty-icon" }, null, -1)
        ])),
        evilLoyaltyIcon: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "evil-loyalty-icon" }, null, -1)
        ])),
        _: 1
      }),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.submitCardsToLeader')), 1),
      _createVNode(_component_i18n_t, {
        keypath: "rules.cardsRevealed",
        tag: "li",
        scope: "global"
      }, {
        goodLoyaltyIcon: _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("span", { class: "good-loyalty-icon" }, null, -1)
        ])),
        evilLoyaltyIcon: _withCtx(() => _cache[6] || (_cache[6] = [
          _createElementVNode("span", { class: "evil-loyalty-icon" }, null, -1)
        ])),
        _: 1
      })
    ]),
    _createElementVNode("h3", null, "3. " + _toDisplayString(_ctx.$t('rules.progressionOfPlayTitle')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.leaderTokenMove')), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.newRound')), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.playersUseSkills')), 1)
    ]),
    _createVNode(_component_v_divider, { thickness: 5 }),
    _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t('rules.conclusionOfGameplayTitle')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "rules.gameplayEndsCondition" })
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('rules.strategicDiscussion')), 1),
    _createVNode(_component_v_divider, { thickness: 5 }),
    _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('rules.missionSizes')), 1),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("table", {
        "aria-label": _ctx.$t('rules.missionSizes')
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('rules.numberOfPlayers')), 1),
            _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('rules.teamBalance')), 1),
            _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('rules.missionNumber', { number: 1 })), 1),
            _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('rules.missionNumber', { number: 2 })), 1),
            _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('rules.missionNumber', { number: 3 })), 1),
            _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('rules.missionNumber', { number: 4 })), 1),
            _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('rules.missionNumber', { number: 5 })), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 5 })), 1),
            _cache[7] || (_cache[7] = _createElementVNode("td", null, "3 / 2", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("td", null, "2", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("td", null, "3", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("td", null, "2", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("td", null, "3", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("td", null, "3", -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 6 })), 1),
            _cache[13] || (_cache[13] = _createElementVNode("td", null, "4 / 2", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("td", null, "2", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("td", null, "3", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("td", null, "4", -1)),
            _cache[17] || (_cache[17] = _createElementVNode("td", null, "3", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("td", null, "4", -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 7 })), 1),
            _cache[19] || (_cache[19] = _createElementVNode("td", null, "4 / 3", -1)),
            _cache[20] || (_cache[20] = _createElementVNode("td", null, "2", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("td", null, "3", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("td", null, "3", -1)),
            _cache[23] || (_cache[23] = _createElementVNode("td", null, "4*", -1)),
            _cache[24] || (_cache[24] = _createElementVNode("td", null, "4", -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 8 })), 1),
            _cache[25] || (_cache[25] = _createElementVNode("td", null, "5 / 3", -1)),
            _cache[26] || (_cache[26] = _createElementVNode("td", null, "3", -1)),
            _cache[27] || (_cache[27] = _createElementVNode("td", null, "4", -1)),
            _cache[28] || (_cache[28] = _createElementVNode("td", null, "4", -1)),
            _cache[29] || (_cache[29] = _createElementVNode("td", null, "5*", -1)),
            _cache[30] || (_cache[30] = _createElementVNode("td", null, "5", -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 9 })), 1),
            _cache[31] || (_cache[31] = _createElementVNode("td", null, "6 / 3", -1)),
            _cache[32] || (_cache[32] = _createElementVNode("td", null, "3", -1)),
            _cache[33] || (_cache[33] = _createElementVNode("td", null, "4", -1)),
            _cache[34] || (_cache[34] = _createElementVNode("td", null, "4", -1)),
            _cache[35] || (_cache[35] = _createElementVNode("td", null, "5*", -1)),
            _cache[36] || (_cache[36] = _createElementVNode("td", null, "5", -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 10 })), 1),
            _cache[37] || (_cache[37] = _createElementVNode("td", null, "6 / 4", -1)),
            _cache[38] || (_cache[38] = _createElementVNode("td", null, "3", -1)),
            _cache[39] || (_cache[39] = _createElementVNode("td", null, "4", -1)),
            _cache[40] || (_cache[40] = _createElementVNode("td", null, "4", -1)),
            _cache[41] || (_cache[41] = _createElementVNode("td", null, "5*", -1)),
            _cache[42] || (_cache[42] = _createElementVNode("td", null, "5", -1))
          ])
        ])
      ], 8, _hoisted_19)
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t('rules.note')), 1),
      _createVNode(_component_i18n_t, {
        keypath: "rules.twoFailsNote",
        tag: "span",
        scope: "global"
      }, {
        evilLoyaltyIcon: _withCtx(() => _cache[43] || (_cache[43] = [
          _createElementVNode("span", { class: "evil-loyalty-icon" }, null, -1)
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_v_divider, { thickness: 5 }),
    _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.$t('rules.recommendTitle')), 1),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.generalTipsTitle')), 1),
    _createElementVNode("p", {
      innerHTML: _ctx.$t('rules.generalTipsText')
    }, null, 8, _hoisted_34),
    _createElementVNode("p", {
      innerHTML: _ctx.$t('rules.newcomersAdvice')
    }, null, 8, _hoisted_35),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('rules.recommendationAfterFirstGames')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_PreviewLink, { target: "merlin" }),
      _cache[44] || (_cache[44] = _createTextVNode(" -> ")),
      _createVNode(_component_PreviewLink, { target: "percival" }),
      _cache[45] || (_cache[45] = _createTextVNode(" -> ")),
      _createVNode(_component_PreviewLink, { target: "morgana" }),
      _cache[46] || (_cache[46] = _createTextVNode(" -> ")),
      _createVNode(_component_PreviewLink, { target: "oberon" }),
      _cache[47] || (_cache[47] = _createTextVNode(" -> ")),
      _createVNode(_component_PreviewLink, { target: "mordred" }),
      _cache[48] || (_cache[48] = _createTextVNode(" -> ")),
      _createVNode(_component_PreviewLink, { target: "ladyOfLake" }),
      _cache[49] || (_cache[49] = _createTextVNode(" -> ")),
      _createVNode(_component_PreviewLink, { target: "tristan" }),
      _cache[50] || (_cache[50] = _createTextVNode(" + ")),
      _createVNode(_component_PreviewLink, { target: "isolde" })
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 5 })) + ":", 1),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.servantTeam')), 1),
      _cache[51] || (_cache[51] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "merlin" }),
      _cache[52] || (_cache[52] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "percival" }),
      _cache[53] || (_cache[53] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.mordredTeam')), 1),
      _cache[55] || (_cache[55] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "mordred" }),
      _cache[56] || (_cache[56] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "morgana" })
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 6 })) + ":", 1),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.servantTeam')), 1),
      _cache[57] || (_cache[57] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "merlin" }),
      _cache[58] || (_cache[58] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "percival" }),
      _cache[59] || (_cache[59] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[60] || (_cache[60] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.mordredTeam')), 1),
      _cache[62] || (_cache[62] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "mordred" }),
      _cache[63] || (_cache[63] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "morgana" })
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 7 })) + ":", 1),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.servantTeam')), 1),
      _cache[64] || (_cache[64] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "merlin" }),
      _cache[65] || (_cache[65] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "percival" }),
      _cache[66] || (_cache[66] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[67] || (_cache[67] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[68] || (_cache[68] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.mordredTeam')), 1),
      _cache[69] || (_cache[69] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "mordred" }),
      _cache[70] || (_cache[70] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "morgana" }),
      _cache[71] || (_cache[71] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "minion" }),
      _cache[72] || (_cache[72] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("em", null, _toDisplayString(_ctx.$t('rules.expansions')), 1),
      _cache[73] || (_cache[73] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "ladyOfLake" })
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 8 })) + ":", 1),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.servantTeam')), 1),
      _cache[74] || (_cache[74] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "merlin" }),
      _cache[75] || (_cache[75] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "percival" }),
      _cache[76] || (_cache[76] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[77] || (_cache[77] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[78] || (_cache[78] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[79] || (_cache[79] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.mordredTeam')), 1),
      _cache[80] || (_cache[80] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "mordred" }),
      _cache[81] || (_cache[81] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "morgana" }),
      _cache[82] || (_cache[82] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "minion" }),
      _cache[83] || (_cache[83] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("em", null, _toDisplayString(_ctx.$t('rules.expansions')), 1),
      _cache[84] || (_cache[84] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "ladyOfLake" })
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 9 })) + ":", 1),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.servantTeam')), 1),
      _cache[85] || (_cache[85] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "merlin" }),
      _cache[86] || (_cache[86] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "percival" }),
      _cache[87] || (_cache[87] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "tristan" }),
      _cache[88] || (_cache[88] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "isolde" }),
      _cache[89] || (_cache[89] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[90] || (_cache[90] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[91] || (_cache[91] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.mordredTeam')), 1),
      _cache[92] || (_cache[92] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "mordred" }),
      _cache[93] || (_cache[93] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "morgana" }),
      _cache[94] || (_cache[94] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "minion" }),
      _cache[95] || (_cache[95] = _createElementVNode("br", null, null, -1))
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('rules.countPlayers', { count: 10 })) + ":", 1),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.servantTeam')), 1),
      _cache[96] || (_cache[96] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "merlin" }),
      _cache[97] || (_cache[97] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "percival" }),
      _cache[98] || (_cache[98] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "tristan" }),
      _cache[99] || (_cache[99] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "isolde" }),
      _cache[100] || (_cache[100] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[101] || (_cache[101] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "servant" }),
      _cache[102] || (_cache[102] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.mordredTeam')), 1),
      _cache[103] || (_cache[103] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "mordred" }),
      _cache[104] || (_cache[104] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "morgana" }),
      _cache[105] || (_cache[105] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "minion" }),
      _cache[106] || (_cache[106] = _createTextVNode(", ")),
      _createVNode(_component_PreviewLink, { target: "oberon" }),
      _cache[107] || (_cache[107] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("em", null, _toDisplayString(_ctx.$t('rules.expansions')), 1),
      _cache[108] || (_cache[108] = _createTextVNode()),
      _createVNode(_component_PreviewLink, { target: "ladyOfLake" })
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t('rules.note')), 1),
      _cache[109] || (_cache[109] = _createTextVNode()),
      _createElementVNode("span", {
        innerHTML: _ctx.$t('rules.assassinNote')
      }, null, 8, _hoisted_42)
    ]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('addons.excalibur')) + ":", 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "rules.excaliburHint" })
    ]),
    _createVNode(_component_v_divider, { thickness: 5 }),
    _createElementVNode("h2", _hoisted_43, _toDisplayString(_ctx.$t('rules.faqTitle')), 1),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Players', 'Tie', 'Merlin'], (topic) => {
      return _createElementVNode("section", { key: topic }, [
        _createElementVNode("h3", {
          id: `faq-${topic.toLowerCase()}`
        }, _toDisplayString(_ctx.$t(`rules.faq${topic}Question`)), 9, _hoisted_44),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`rules.faq${topic}Answer`)), 1)
      ])
    }), 64)),
    _createVNode(_component_v_divider, { thickness: 5 }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('rules.offlineSetup')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "rules.defaultSetup" })
    ]),
    _createElementVNode("div", _hoisted_45, [
      (_ctx.roleOptionsComponent)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.roleOptionsComponent), {
            key: 0,
            ref: "roleOptions",
            roles: _ctx.roles,
            buttonText: _ctx.$t('options.roles'),
            onApply: _cache[0] || (_cache[0] = ($event: any) => (Object.assign(_ctx.roles, $event.roles)))
          }, null, 40, ["roles", "buttonText"]))
        : (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            color: "info",
            loading: _ctx.roleOptionsLoading,
            "data-load-role-options": "",
            onClick: _ctx.openRoleOptions
          }, {
            prepend: _withCtx(() => _cache[110] || (_cache[110] = [
              _createElementVNode("span", {
                class: "material-icons",
                "aria-hidden": "true"
              }, "settings", -1)
            ])),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.$t('options.roles')), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
    ], 512),
    _createElementVNode("ol", _hoisted_46, [
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.closeEyesExtendHand')), 1),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, [
          _createVNode(_component_PreviewLink, { target: "minion" })
        ]),
        (_ctx.roles.oberon || _ctx.roles.evilLancelot)
          ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
              _createTextVNode(" (" + _toDisplayString(_ctx.$t('rules.except')) + " ", 1),
              _createElementVNode("strong", null, [
                (_ctx.roles.oberon)
                  ? (_openBlock(), _createBlock(_component_PreviewLink, {
                      key: 0,
                      target: "oberon"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.roles.evilLancelot)
                  ? (_openBlock(), _createBlock(_component_PreviewLink, {
                      key: 1,
                      target: "evilLancelot"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _cache[111] || (_cache[111] = _createTextVNode(") "))
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.seeAllAgentsOfEvil')), 1)
      ]),
      (_ctx.roles.evilLancelot)
        ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
            _createElementVNode("strong", null, [
              _createVNode(_component_PreviewLink, { target: "evilLancelot" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.extendYourThumbSo')) + " ", 1),
            _createElementVNode("strong", null, [
              _createVNode(_component_PreviewLink, { target: "minion" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.willKnowOfYou')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, [
          _createVNode(_component_PreviewLink, { target: "minion" })
        ]),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.closeEyes')), 1)
      ]),
      (_ctx.roles.guinevere)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("li", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_PreviewLink, { target: "goodLancelot" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.extendYourThumbSo')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_PreviewLink, { target: "guinevere" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.guinevereLookAround')), 1)
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.roles.evilLancelot)
        ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
            _createElementVNode("strong", null, [
              _createVNode(_component_PreviewLink, { target: "evilLancelot" }),
              (_ctx.roles.guinevere)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[112] || (_cache[112] = _createTextVNode(" ")),
                    _createVNode(_component_PreviewLink, { target: "goodLancelot" })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.putYourThumbDown')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.allPlayersShouldHaveEyedClosed')), 1),
      (_ctx.roles.merlinPure || _ctx.roles.merlin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (_ctx.roles.merlin)
              ? (_openBlock(), _createElementBlock("li", _hoisted_50, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_PreviewLink, { target: "minion" })
                  ]),
                  (_ctx.roles.mordred)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                        _createTextVNode(" (" + _toDisplayString(_ctx.$t('rules.except')) + " ", 1),
                        _createElementVNode("strong", null, [
                          _createVNode(_component_PreviewLink, { target: "mordred" })
                        ]),
                        _cache[113] || (_cache[113] = _createTextVNode(")"))
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.extendYourThumbSo')) + " ", 1),
                  (_ctx.roles.merlin)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                        _createElementVNode("strong", null, [
                          _createVNode(_component_PreviewLink, { target: "merlin" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.willKnowOfYou')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.roles.merlinPure)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_PreviewLink, { target: "merlinPure" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.merlinOpenEyes')), 1)
                  ]),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { target: 'oberon' },
              { target: 'lunatic' },
              { target: 'brute' },
              { target: 'evilLancelot' },
              { target: 'trickster' },
              { target: 'morgana' },
              { target: 'witch' },
              { target: 'revealer' },
            ] as const, (role) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (_ctx.roles[role.target])
                        ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                            _createElementVNode("strong", null, [
                              _createVNode(_component_PreviewLink, {
                                target: role.target
                              }, null, 8, ["target"])
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.extendYourThumb')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 64)),
                  _createElementVNode("li", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('rules.ordinaryMinion')), 1),
                    _cache[114] || (_cache[114] = _createTextVNode(" ")),
                    _createElementVNode("strong", null, [
                      _createVNode(_component_PreviewLink, { target: "minion" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.extendYourThumb')), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.roles.merlin)
              ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_PreviewLink, { target: "merlin" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.merlinOpenEyes')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_PreviewLink, { target: "minion" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.putYourThumbDown')), 1)
            ]),
            _createElementVNode("li", null, [
              (_ctx.roles.merlin)
                ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_PreviewLink, { target: "merlin" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.roles.merlinPure)
                ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_PreviewLink, { target: "merlinPure" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.closeEyes')), 1)
            ]),
            (_ctx.roles.percival)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("li", null, [
                    (_ctx.roles.merlin)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_PreviewLink, { target: "merlin" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.roles.merlinPure)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_PreviewLink, { target: "merlinPure" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.roles.morgana)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                          _createElementVNode("strong", null, [
                            _cache[115] || (_cache[115] = _createTextVNode(" ")),
                            _createVNode(_component_PreviewLink, { target: "morgana" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.extendYourThumbSo')) + " ", 1),
                    _createElementVNode("strong", null, [
                      _createVNode(_component_PreviewLink, { target: "percival" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.willKnowOfYou')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_PreviewLink, { target: "percival" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.percivalOpenEyes')) + " ", 1),
                    (_ctx.roles.merlin)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_PreviewLink, { target: "merlin" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.roles.merlinPure)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_PreviewLink, { target: "merlinPure" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.roles.morgana)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                          _createElementVNode("strong", null, [
                            _cache[116] || (_cache[116] = _createTextVNode(" ")),
                            _createVNode(_component_PreviewLink, { target: "morgana" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _cache[117] || (_cache[117] = _createTextVNode(". "))
                  ]),
                  _createElementVNode("li", null, [
                    (_ctx.roles.merlin)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_PreviewLink, { target: "merlin" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.roles.merlinPure)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_PreviewLink, { target: "merlinPure" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.roles.morgana)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                          _createElementVNode("strong", null, [
                            _cache[118] || (_cache[118] = _createTextVNode(" ")),
                            _createVNode(_component_PreviewLink, { target: "morgana" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.putYourThumbDown')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_PreviewLink, { target: "percival" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.closeEyes')), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.roles.tristan)
        ? (_openBlock(), _createElementBlock("li", _hoisted_66, [
            _createElementVNode("strong", null, [
              _createVNode(_component_PreviewLink, { target: "tristan" }),
              _cache[119] || (_cache[119] = _createTextVNode()),
              _createVNode(_component_PreviewLink, { target: "isolde" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('rules.loversOpenEyes')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.allPlayersShouldHaveEyedClosed')), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t('rules.everyoneOpenEyes')), 1)
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('rules.note')), 1),
      _cache[120] || (_cache[120] = _createTextVNode()),
      _createVNode(_component_LocalizedTextWrapper, { keypath: "rules.gameSetupNote" })
    ]),
    _createVNode(_component_WikiPlayCta, { "show-rules": false })
  ]))
}